import { render, staticRenderFns } from "./confirmRefund.vue?vue&type=template&id=7b8fffa1&scoped=true&"
import script from "./confirmRefund.vue?vue&type=script&lang=js&"
export * from "./confirmRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8fffa1",
  null
  
)

export default component.exports